import React from 'react'
import withLayout from '../withLayout'


const EmptyPage = () => {
    return <div/>
}

export default withLayout(EmptyPage)



// WEBPACK FOOTER //
// ./src/modules/layout/component/EmptyPage.js